import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {Navbar} from '../Navbar/Navbar'

import './Main.css'

export function Main({ 
        breadcrumbsItems = [] , 
        size ='', 
        withNav = true, 
        positionY='top' , 
        mutedBackground = false,
        className = '',
        children }) {

    const { user , org } = useSelector((state) => state.auth)
    const {general} = useSelector((state) => state.ui)

    let mainClass = ['main'];
    if(size) mainClass.push(size);
    if(user && general?.show_sidebar === true) mainClass.push('sidebar_opened');
    if(mutedBackground) mainClass.push('bg-muted');
    if(className) mainClass.push(className);

    mainClass = mainClass.join(' ')
 

	return (
		<div className={mainClass}>
			{ withNav === true && <Navbar breadcrumbs={breadcrumbsItems}/>}
			<div className={`body ${positionY ? `y${positionY}` : ''}`}>
				<div className="container">
					<div className="content-wrapper">
						{children}
					</div>
				</div>
			</div>
		</div>
	)
}

